import React, { useState, useEffect } from 'react';
import './MakenAanpassenProductScreen.css';
import { Form, Button, Input, Select,  Spin, Tooltip } from 'antd';
import {InfoCircleFilled, ArrowLeftOutlined} from '@ant-design/icons' 
import { useLocation, useNavigate } from 'react-router-dom';
import AxiosCaller from '../../../../authenticatie/AxiosCaller';
import { ArrowLeft } from 'lucide-react';
import { openNotificationSuccess, openNotificationError } from '../../../../Components/Notification/Notification';

const MakenAanpassenProductScreen = () => {
  const { get, put, post } = AxiosCaller();
  const navigate = useNavigate();
  const location = useLocation();
  const product = location.state;

  const [name, setName] = useState('');
  const [eenheid, setUnit] = useState(''); // Only store _id here
  const [selectedAllergen, setSelectedAllergen] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [hoeveelheid, setHoeveelheid] = useState('');
  const [minimumHoeveelheid, setMinimumHoeveelheid] = useState('');
  const [omzettingsEenheid, setOmzettingsEenheid] = useState('');
  const [locatie, setLocatie] = useState('');
  const [suppliers, setSuppliers] = useState([]);
  const [locaties, setLocaties] = useState([]);
  const [eenheden, setEenheden] = useState([]);
  const [allergens, setAllergens] = useState([]);
  const [allergensList, setAllergensList] = useState([]);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);  // Loading state
     const [maxHeight, setMaxHeight] = useState(0);
      
          useEffect(() => {
              const updateHeight = () => {
                  setMaxHeight(0.7 * document.documentElement.clientHeight);
              };
      
              updateHeight(); // Initialiseren bij eerste render
              window.addEventListener("resize", updateHeight); // Updaten bij schermresizing
      
              return () => window.removeEventListener("resize", updateHeight); // Cleanup
          }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          fetchSuppliers(),
          fetchLocaties(),
          fetchEenheden(),
          fetchAllergenen()
        ]);

        setLoading(false); // Data is loaded, set loading to false
      } catch (error) {
        console.error('Error fetching data', error);
        openNotificationError("Fout bij ophalen van de data" , error)
        setLoading(false);
      }
    };

    fetchData();

    if (product) {
      updateFields(product);
    }
  }, [product]);

  const fetchSuppliers = async () => {
    try{
      const response = await get('/leverancier');
    setSuppliers(response.data);

    }catch(error){
      console.error(error)
      openNotificationError("Fout bij ophalen van leveranciers", error)
    }
    
  };

  const fetchLocaties = async () => {
    try{

      const response = await get('/locatie');
    setLocaties(response.data);
    }catch(error){
      console.error(error)
      openNotificationError("Fout bij ophalen van locaties", error)
    }
 
  };

  const fetchEenheden = async () => {
    try{
      const response = await get('/eenheid');
    setEenheden(response.data);

    }catch(error){
      console.error(error)
      openNotificationError("Fout bij ophalen van eenheden", error)
    }
    
  };

  const fetchAllergenen = async () => {
    try{
      const response = await get('/allergeen');
      setAllergens(response.data);
    }catch(error){
      console.error(error)
      openNotificationError("Fout bij ophalen van allergenen", error)
    }
  };

  const updateFields = (product) => {
    setName(product.naam);
    setUnit(product.eenheid._id);  // Ensure we only store _id
    setSelectedSupplier(product.leverancier);
    setLocatie(product.locatie);
    setAllergensList(product.allergenen);
    setHoeveelheid((1 / product.omzetting.factor));
    setMinimumHoeveelheid(product.minimumHoeveelheid);
    setOmzettingsEenheid(product.omzetting.eenheid._id);

    // Update form values using setFieldsValue
    form.setFieldsValue({
      name: product.naam,
      selectedSupplier: product.leverancier._id,
      locatie: product.locatie._id,
      hoeveelheid: (1 / product.omzetting.factor),
      minimumHoeveelheid: product.minimumHoeveelheid,
      omzettingsEenheid: product.omzetting.eenheid._id,
      allergensList: product.allergenen.map(allergen => allergen._id),
      eenheid: product.eenheid._id,  // Pass only the _id for eenheid
    });
  };

  const handleAddProduct = async () => {
    try {
      const formValues = await form.validateFields(); 

      if (!name || !selectedSupplier || !hoeveelheid || !omzettingsEenheid || !eenheid) {
        openNotificationError('Naam, Eenheid, hoeveelheid, omzettingsEenheid en Leverancier zijn verplicht.')
        return;
      }

      const SelectedAllergensIds = allergensList.map(allergen => allergen._id); 
      const productData = {
        naam: name,
        eenheid: eenheid,  // Send only _id of eenheid
        allergenen: SelectedAllergensIds, 
        leverancier: selectedSupplier,
        locatie: locatie,
        aantal: hoeveelheid,
        omzettingsEenheid: omzettingsEenheid,
        minimumHoeveelheid: minimumHoeveelheid,
      };

      if (product) {
        await updateProduct(productData);
      } else {
        await AddProduct(productData);
      }

      form.resetFields();
      navigate('/Admin/configuratie/producten');
    } catch (error) {
      console.error('Product creation error', error);
      openNotificationError("Fout bij opslaan van product", error)
    }
  };

  const AddProduct = async (productData) => {
    try {
      await post('/product', productData);
     
    } catch (error) {
      console.error('Error adding product', error);
      throw error
    }
  };

  const updateProduct = async (productData) => {
    try {
      await put(`/product/${product._id}`, productData);
    
    } catch (error) {
      console.error('Error updating product', error);
      throw error;
    }
  };

  const terug = () => {
    navigate('/Admin/configuratie/Producten');
  };

  // Render loading spinner if data is being fetched
  if (loading) {
    return <Spin size="large" style={{ marginTop: '20%', display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />;
  }

  return (
    <div className="Screen-container">
      <div className="title-container space">
      <div className="flex gap">
        <ArrowLeftOutlined className="back-arrow" onClick={terug} />
        <h1 className="title">Product Toevoegen / Bewerken</h1>
        </div>
      </div>

      <div className="Screen-mainContent" >
        <div className="form" style={{ overflowY: "auto", maxHeight }}>
          <Form
            form={form}
            onFinish={handleAddProduct}
            layout="vertical"
          >
            <Form.Item
              label="Naam"
              name="name"
              rules={[{ required: true, message: 'Vul de productnaam in' }]} 
            >
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Voer productnaam in"
              />
            </Form.Item>

            <Form.Item
              label="Leverancier"
              name="selectedSupplier"
              rules={[{ required: true, message: 'Selecteer een leverancier' }]} 
            >
              <Select
                value={selectedSupplier?._id}
                onChange={(value) => setSelectedSupplier(value)}
                placeholder="Selecteer leverancier"
                options={suppliers.map((supplier) => ({ value: supplier._id, label: supplier.naam }))} 
              />
            </Form.Item>

            <Form.Item
              label="Locatie"
              name="locatie"
              rules={[{ required: true, message: 'Selecteer een locatie' }]} 
            >
              <Select
                value={locatie?._id}
                onChange={(value) => setLocatie(value)}
                placeholder="Selecteer locatie"
                options={locaties.map((locatie) => ({ value: locatie._id, label: locatie.naam }))} 
              />
            </Form.Item>
            <Form.Item
               label={
                <span>
                  Eenheid
                  <Tooltip title="Dit is de kleinste eenheid dat je mee werkt">
                    <InfoCircleFilled style={{ marginLeft: 5 }} />
                  </Tooltip>
                </span>
              }
                name="eenheid"
                rules={[{ required: true, message: 'Selecteer een eenheid' }]}
              >
                <Select
                  value={eenheid} // Use only _id for eenheid
                  onChange={(value) => setUnit(value)}
                  placeholder="Selecteer eenheid"
                  showSearch  // Enable search functionality
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())  // Filter by label
                  }
                  options={eenheden.map((eenheid) => ({ value: eenheid._id, label: eenheid.naam }))} 
                />
              </Form.Item>


            <Form.Item
             label= {
              <span>
                hoeveelheid per omzettings eenheid
                <Tooltip title="hoeveel stuk,g,... zit er in 1 omzettingseenheid bv 35 stuks in 1 pak dan neem je de 35">
                  <InfoCircleFilled style={{ marginLeft: 5 }} />
                </Tooltip>
              </span>
              }
              name="hoeveelheid"
              rules={[{ required: true, message: 'Voer de hoeveelheid in' }]} 
            >
              <Input
                type="number"
                value={hoeveelheid}
                onChange={(e) => setHoeveelheid(e.target.value)}
                placeholder="Geef een hoeveelheid in"
                min={1}
              />
            </Form.Item>

         

            <Form.Item
              label={
                <span>
                  Omzettings Eenheid
                  <Tooltip title="Dit is de grootste eenheid dat je besteld">
                    <InfoCircleFilled style={{ marginLeft: 5 }} />
                  </Tooltip>
                </span>
              }
              name="omzettingsEenheid"
              rules={[{ required: true, message: 'Selecteer de omzettings eenheid' }]}
            >
              <Select
                value={omzettingsEenheid}
                onChange={(value) => setOmzettingsEenheid(value)}
                options={eenheden.map((eenheid) => ({ value: eenheid._id, label: eenheid.naam }))}
                showSearch  // Enable search functionality
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())  // Filter by label
                }
                placeholder="Selecteer omzettings eenheid"
              />
            </Form.Item>


            <Form.Item
                 label={
                  <span>
                    Stap grootte
                    <Tooltip title="Dit is met hoeveel een leerkracht mag verspringen bij het aanpassen van de producten in het menu">
                      <InfoCircleFilled style={{ marginLeft: 5 }} />
                    </Tooltip>
                  </span>
                }
              name="minimumHoeveelheid"
              rules={[{ required: true, message: 'geef een stapgrootte in'}]}
              >
              <Input
                type="number"
                value={minimumHoeveelheid}
                onChange={(e) => setMinimumHoeveelheid(e.target.value)}
                placeholder="Geef een stapgrootte in"
                min={1}
              />
              
            </Form.Item>

            <Form.Item label="Allergenen" name="allergensList">
              <Select
                mode="multiple"
                value={allergensList.map(allergen => allergen._id)}
                onChange={(value) => {
                  setAllergensList(allergens.filter(allergen => value.includes(allergen._id)));
                }}
                placeholder="Selecteer allergenen"
                options={allergens.map(allergen => ({
                  value: allergen._id,
                  label: allergen.naam,
                }))}
                filterOption={(input, option) => 
                  option.label.toLowerCase().includes(input.toLowerCase())  // Zoek op de naam (label)
                }
              />
            </Form.Item>


            <Button type="primary" htmlType="submit">
              {product ? 'Product Bijwerken' : 'Voeg Product Toe'}
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default MakenAanpassenProductScreen;
